﻿import * as angular from "angular";

import { MaintenanceMessage } from "../Model/MaintenanceMessage";
import { User } from "../Model/User";
import { CredentialChallengeOptions } from "../Model/CredentialChallengeOptions";

class DataService {
    private async doFetch<T>(path: string, body: any = null) {
        const response = await fetch(path, {
            method: body ? "POST" : "GET",
            body: body ? JSON.stringify(body) : null,
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.ok) {
            return response.status === 204 ? null : (response.json() as T);
        } else {
            throw new Error(response.statusText);
        }
    }

    async authenticated() {
        return this.doFetch<User>("api/authenticated");
    }

    async maintenance() {
        return this.doFetch<MaintenanceMessage>("api/maintenance");
    }

    async password(username: string) {
        return this.doFetch<number>("api/passwordauth", username);
    }

    async passwordless(username: string) {
        return this.doFetch<CredentialChallengeOptions>(
            "api/passwordlessauth",
            username,
        );
    }

    async settings(userId: string) {
        return this.doFetch<number>(
            "api/Recover/PasswordRequirement/" + userId,
        );
    }

    async validatePassword(userId: string, password: string) {
        return this.doFetch<number[]>(
            "api/Recover/ValidatePassword/" + userId,
            { Password: password },
        );
    }

    async username(username: string) {
        return this.doFetch("api/passwordauth", username);
    }

    async twoFactorInit(id: string, secret: string) {
        return this.doFetch<{ item1: string; item2: string }>(
            "api/TwoFactorInit?id=" +
                id +
                "&secret=" +
                encodeURIComponent(secret),
        );
    }
}

angular.module("datastore").factory("dataService", function () {
    return new DataService();
});

export default DataService;
